import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { FormsModule } from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import {
    FormItemComponent, ButtonComponent, FormFieldDirective,
    ToastComponent, SelectComponent, SpinnerComponent, CheckboxComponent, PaginationComponent, RadioComponent, RadioGroupComponent,
    ToastService,
    TabsComponent,
    TabComponent, MultiSelectComponent, ListItemComponent
} from '@engie-group/fluid-design-system-angular';
import { HeaderComponent } from './features/shared/header/header.component';
// import { OAuthModule, OAuthModuleConfig } from 'angular-oauth2-oidc';
// import { AuthStateService, IAM_CONFIG } from './core/services/auth-state.service';
import { environment } from 'src/environments/environment';
import { CallbackComponent } from './login/callback/callback.component';
import { LogoutComponent } from './login/logout/logout.component';
import { APIInterceptor } from './core/api.interceptor';
import { ToastViewerComponent } from './features/shared/toast/toast.component';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AdhocInstructionsComponent } from './features/dashboards/grids/adhoc-instructions/adhoc-instructions.component';
import { TradersDashboardComponent } from './features/dashboards/traders-dashboard/traders-dashboard.component';
import { MorayEastDashboardComponent } from './features/dashboards/moray-east-dashboard/moray-east-dashboard.component';
import { MorayEastInstructionsComponent } from './features/dashboards/grids/moray-east-instructions/moray-east-instructions.component';
import { MorayEastComponent } from './features/instructions-entry/moray-east/moray-east.component';
import { AdHocComponent } from './features/instructions-entry/ad-hoc/ad-hoc.component';
import { AdhocDashboardComponent } from './features/dashboards/adhoc-dashboard/adhoc-dashboard.component';
import { AdHocRetailComponent } from './features/instructions-entry/ad-hoc-retail/ad-hoc-retail.component';
import { MorayWestInstructionsComponent } from './features/dashboards/grids/moray-west-instructions/moray-west-instructions.component';
import { MorayWestDashboardComponent } from './features/dashboards/moray-west-dashboard/moray-west-dashboard.component';
import { MorayWestComponent } from './features/instructions-entry/moray-west/moray-west.component';
import { FhcComponent } from './features/instructions-entry/fhc/fhc.component';
import { FhcDashboardComponent } from './features/dashboards/fhc-dashboard/fhc-dashboard.component';
import { FhcInstructionsComponent } from './features/dashboards/grids/fhc-instructions/fhc-instructions.component';
import {
    SidepanelComponent,
    SidepanelFooterDirective,
    SidepanelHeaderComponent,
    SidepanelHeaderDirective,
    SidepanelLayoutComponent,
    SidepanelLayoutPanelDirective
} from '@engie-group/fluid-design-system-angular';
import { DashboardsViewerComponent } from './features/dashboards-viewer/dashboards-viewer.component';
import { AdHocRetailViewerComponent } from './features/instruction-viewer/ad-hoc-retail-viewer/ad-hoc-retail-viewer.component';
import { AdHocViewerComponent } from './features/instruction-viewer/ad-hoc-viewer/ad-hoc-viewer.component';
import { FhcViewerComponent } from './features/instruction-viewer/fhc-viewer/fhc-viewer.component';
import { MorayEastViewerComponent } from './features/instruction-viewer/moray-east-viewer/moray-east-viewer.component';
import { MorayWestViewerComponent } from './features/instruction-viewer/moray-west-viewer/moray-west-viewer.component';
import { SpaasModule } from '@engie-group/ngx-gem-spaas';
import { ResComponent } from './features/instructions-entry/res/res.component';
import { ResInstructionsComponent } from './features/dashboards/grids/res-instructions/res-instructions.component';
import { ResDashboardComponent } from './features/dashboards/res-dashboard/res-dashboard.component';
import { ResViewerComponent } from './features/instruction-viewer/res-viewer/res-viewer.component';

@NgModule({
    declarations: [
        AppComponent,
        HeaderComponent,
        CallbackComponent,
        LogoutComponent,
        ToastViewerComponent,
        AdhocInstructionsComponent,
        TradersDashboardComponent,
        MorayEastDashboardComponent,
        MorayEastInstructionsComponent,
        MorayEastComponent,
        AdHocComponent,
        AdhocDashboardComponent,
        AdHocRetailComponent,
        MorayWestInstructionsComponent,
        MorayWestDashboardComponent,
        MorayWestComponent,
        FhcComponent,
        FhcDashboardComponent,
        FhcInstructionsComponent,
        DashboardsViewerComponent,
        AdHocRetailViewerComponent,
        AdHocViewerComponent,
        MorayEastViewerComponent,
        MorayWestViewerComponent,
        FhcViewerComponent,
        ResComponent,
        ResInstructionsComponent,
        ResDashboardComponent,
        ResViewerComponent
    ],
    bootstrap: [AppComponent],
    imports: [
        SidepanelComponent,
        SidepanelFooterDirective,
        SidepanelHeaderComponent,
        SidepanelHeaderDirective,
        SidepanelLayoutComponent,
        SidepanelLayoutPanelDirective,
        FormItemComponent, FormFieldDirective, ButtonComponent,
        ToastComponent, SelectComponent, SpinnerComponent, CheckboxComponent,
        PaginationComponent, RadioComponent, RadioGroupComponent,
        TabsComponent, TabComponent, MultiSelectComponent, ListItemComponent,
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        FormsModule,
        SpaasModule.forRoot({
            appName: 'automated-instruction-management',
            environment: environment.env,
            oktaConfig: environment.oktaConfig,
        })], 
        providers: [
            ToastService,
            {
                provide: HTTP_INTERCEPTORS,
                useClass: APIInterceptor,
                multi: true
            },
            provideHttpClient(withInterceptorsFromDi())
        ]
})
export class AppModule { }
